import * as React from 'react';
import '../../styles/components/tooltip.scss';

interface TooltipProps {
    title: string
    message: string
    open: boolean
}
const Tooltip = (props: TooltipProps) => {
    const { title, message, open } = props;
    return (<div className={ `tooltip ${ open ? 'tooltip--open' : ''}`}>
        { title != '' && <div className="tooltip__title">{ title }</div> }
        { message !='' && <div className="tooltip__message">{ message }</div>}
    </div>);
};

export default Tooltip;
